// import React from "react";
// import PolicyPage from "../../components/PolicyPage/PolicyPage";
// import policyData from "./mobileNumerologyPolicyData";

// export default function MobileNumerologyPolicy() {
//   return <PolicyPage data={policyData} />;
// }



import React from "react";
import { Helmet } from "react-helmet-async";
import PolicyPage from "../../components/PolicyPage/PolicyPage";
import policyData from "./mobileNumerologyPolicyData";

export default function MobileNumerologyPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Mobile Numerology Policy | Astro Logical Solutions
        </title>

        <meta
          name="description"
          content="Read the Mobile Numerology Policy of Astro Logical Solutions to understand our numerology guidance, recommendations and service guidelines."
        />

        <link
          rel="canonical"
          href="https://astrologicalsolutions.in/mobile-numerology-policy"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta
          property="og:title"
          content="Mobile Numerology Policy | Astro Logical Solutions"
        />

        <meta
          property="og:description"
          content="Learn about mobile numerology guidance, recommendations and service guidelines at Astro Logical Solutions."
        />

        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/mobile-numerology-policy"
        />

        <meta
          property="og:site_name"
          content="Astro Logical Solutions"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary"
        />

        <meta
          name="twitter:title"
          content="Mobile Numerology Policy | Astro Logical Solutions"
        />

        <meta
          name="twitter:description"
          content="Learn about mobile numerology guidance and service guidelines at Astro Logical Solutions."
        />
      </Helmet>

      <PolicyPage data={policyData} />
    </>
  );
}
